import { defineCatalogue } from '../../i18n';

export const measureCatalogue = defineCatalogue(
  {
    'absent.not_measured': 'Não medido',
    'absent.withheld': 'Retido em grupo pequeno para não identificar ninguém',
    'absent.not_observable': 'O provedor não expõe isto',
    'ncs.sample': 'Comentários analisados {n}',
    'ncs.interval': 'intervalo {interval}',
    'withheld.share': '{share} retido em grupos pequenos para não identificar ninguém.',
    'withheld.biased': 'Quem comenta não representa quem lê.',
    'withheld.electorate': 'Números do cadastro do TSE.',
    'withheld.total': 'Ao todo: {total}',
    'fidelity.MEASURED': 'medido',
    'fidelity.ESTIMATED': 'estimado',
    'fidelity.about': 'fidelidade',
    'fidelity.explain.MEASURED': 'O provedor informou este número.',
    'fidelity.explain.ESTIMATED': 'Calculado a partir do que foi observado.',
    'estimate.label': 'estimativa · v{version}',
    'estimate.confidence': 'confiança {confidence}',
    'estimate.about': 'versão do método',
    'estimate.explain': 'Uma nova versão do método pode mudar este número sem que os dados mudem.',
    'hint.about': 'Sobre {label}',
  },
  {
    'absent.not_measured': 'Not measured',
    'absent.withheld': 'Withheld in a small group to avoid identifying anyone',
    'absent.not_observable': 'The provider does not expose this',
    'ncs.sample': 'Comments analysed {n}',
    'ncs.interval': 'interval {interval}',
    'withheld.share': '{share} withheld in small groups to avoid identifying anyone.',
    'withheld.biased': 'Commenters do not represent readers.',
    'withheld.electorate': 'Numbers from the TSE register.',
    'withheld.total': 'Overall: {total}',
    'fidelity.MEASURED': 'measured',
    'fidelity.ESTIMATED': 'estimated',
    'fidelity.about': 'fidelity',
    'fidelity.explain.MEASURED': 'The provider reported this figure.',
    'fidelity.explain.ESTIMATED': 'Computed from what was observed.',
    'estimate.label': 'estimate · v{version}',
    'estimate.confidence': 'confidence {confidence}',
    'estimate.about': 'method version',
    'estimate.explain': 'A new method version can change this figure without the data changing.',
    'hint.about': 'About {label}',
  },
);

export const mt = measureCatalogue.t;
